import { LayoutComponents } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";

import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 5,
        rows: 3,
        rowsSize: [6, 1, 1],
        colsSize: [1.14, 1, 1, 1, 1],
        colSpan: {
          "0:1": 4,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "Lightweight wall built of 50 mm metal studs, filled with mineral wool, with a single layer of 12.5 mm gypsum boards on each side</br></br>Total thickness: 7.5 cm</br></br>Rw = 41 dB",
                    formatter: "html",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                      fontSize: "14px",
                      lineHeight: "18px",
                      fontWeight: 400,
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  paddingTop: "50%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/18/principle/lightweight-wall-1.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Original sound",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "male voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/original-male-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "female voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/original-female-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "baby crying",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/original-baby-crying.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "party",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/original-party.wav`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Sound through the wall",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "male voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/lightweight-wall-1-male-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "female voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/lightweight-wall-1-female-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "baby crying",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/lightweight-wall-1-baby-crying.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "party",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/18/principle/lightweight-wall-1-party.wav`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
